import React from "react"
import { Browse, LayoutSidebar } from "../router"

export const Browser = () => {
  return (
    <>
      <LayoutSidebar>
        <Browse />
      </LayoutSidebar>
    </>
  )
}
